import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { downloadCsv } from 'src/reducers/reports/notificationOfBaseAmountRevisions';
import { NOTIFICATION_OF_BASE_AMOUNT_REVISION_CSV_FORM } from 'src/constants/FormNames';
import CsvModal from '../../components/Modal/CsvModal';

const validateLength = values => {
  const errors = {};
  if (values.serial_number && !/^\d{3}$/.test(values.serial_number)) {
    errors.serial_number = 'は001〜999までの数字を入力してください。';
  }
  return errors;
};
const CsvModalForm = reduxForm({
  form: NOTIFICATION_OF_BASE_AMOUNT_REVISION_CSV_FORM,
  validate: validateLength
})(CsvModal);

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: data => {
    dispatch(downloadCsv(data, ownProps.yearMonth, ownProps.hideModal));
  }
});

export default connect(null, mapDispatchToProps)(CsvModalForm);
